'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var crypto = require('libp2p-crypto');

var Buffer = require('safe-buffer/').Buffer;

module.exports = {
  verify: function () {
    var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(signature, publicKey, data) {
      var isValid, res, pubKey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (signature) {
                _context.next = 2;
                break;
              }

              throw new Error('No signature given');

            case 2:
              if (publicKey) {
                _context.next = 4;
                break;
              }

              throw new Error('Given publicKey was undefined');

            case 4:
              if (data) {
                _context.next = 6;
                break;
              }

              throw new Error('Given input data was undefined');

            case 6:
              if (!Buffer.isBuffer(data)) {
                data = Buffer.from(data);
              }

              isValid = function isValid(key, msg, sig) {
                return new Promise(function (resolve, reject) {
                  key.verify(msg, sig, function (err, valid) {
                    if (!err) {
                      resolve(valid);
                    }

                    reject(valid);
                  });
                });
              };

              res = false;
              _context.prev = 9;
              pubKey = crypto.keys.supportedKeys.secp256k1.unmarshalSecp256k1PublicKey(Buffer.from(publicKey, 'hex'));
              _context.next = 13;
              return isValid(pubKey, data, Buffer.from(signature, 'hex'));

            case 13:
              res = _context.sent;
              _context.next = 18;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](9);

            case 18:
              return _context.abrupt("return", Promise.resolve(res));

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 16]]);
    }));

    function verify(_x, _x2, _x3) {
      return _verify.apply(this, arguments);
    }

    return verify;
  }()
};